import { tap } from 'rxjs/operators';
import { TextosPredefinidosFilter } from './../../models/textos-predefinidos-filter.model';
import { CFG_TEXTOS_PREDEFINIDOS } from './../../../../../models/CFG_TEXTOS_PREDEFINIDOS';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSort } from '@angular/material';
import { CustomDataSource } from 'path-shared/services/datasource/custom.datasource';
import { FilterService } from 'path-shared/services/filter/filter.service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { merge } from 'rxjs';
import { DownloadExcelDialogComponent } from 'path-shared/components/dialogs/download-excel-dialog/download-excel-dialog.component';
import { TextosPredefindiosService } from '../../services/textos-prefedefinidos.service';
import { TextosPredefinidosFilterService } from '../../services/textos-prefedefinidos-filter.service';
import { Builder } from 'path-shared/models/builder';

@Component({
  selector: 'app-textos-predefinidos-table',
  templateUrl: './textos-predefinidos-table.component.html',
  styleUrls: ['./textos-predefinidos-table.component.scss']
})
export class TextosPredefinidosTableComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  data: CFG_TEXTOS_PREDEFINIDOS[];
  dataSource: CustomDataSource<CFG_TEXTOS_PREDEFINIDOS, TextosPredefinidosFilter>;
  filter: TextosPredefinidosFilter = new TextosPredefinidosFilter('descripcion', 'asc');
  displayedItems = [];
  highlightedRows = [];

  @Input() selectButton: boolean;
  @Input() updatedFilterData: TextosPredefinidosFilter;
  @Output() notify: EventEmitter<number> = new EventEmitter<number>();
  @Output() itemClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() itemSelected: EventEmitter<string> = new EventEmitter<string>();

  displayedColumns = ['id', 'alias','descripcio' ];

  constructor(
    private textosPredefinidosService: TextosPredefindiosService,
    private filterService: FilterService,
    private dialog: MatDialog,
    private i18n: I18n
  ) {
  }

  ngOnInit() {
    if (this.selectButton) {
      this.displayedColumns = ['incorpora'].concat(this.displayedColumns);
    }
    this.sort.disableClear = true;
    this.dataSource = CustomDataSource.create<CFG_TEXTOS_PREDEFINIDOS, TextosPredefinidosFilter>(this.paginator, new TextosPredefinidosFilterService(), 'urlGetTextosPredefinidos', 'urlGetTextosPredefinidosCount');
    this.dataSource.subject.subscribe((data) => {
      data.forEach(item => {
        this.displayedItems[item.secureId] = {
          id: item.secureId
        };
      });
    });

    this.filter.filterUpdated.subscribe(updated => {
      if (updated) {
        this.load();
        if (!this.selectButton) { this.filterService.saveFilter('textosPredefinidos-filter', this.filter); }
      }
    });

    if (!this.selectButton) { this.filterService.loadFilter('textosPredefinidos-filter', this.filter); }
    this.filter.paginator.init(this.sort, this.paginator);
  }

  ngAfterViewInit() {
    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.filter.paginator.set(this.sort, this.paginator);
      this.filter.updated();
    });

    merge(this.sort.sortChange, this.paginator.page)
    .pipe(tap(() => this.filter.updated()))
    .subscribe();

    this.load();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.updatedFilterData != null) {
      this.update();
    }
  }

  update() {
    if (this.dataSource !== undefined) {
      this.updatedFilterData.paginator.set(this.sort, this.paginator);
      this.dataSource.loadFilter(this.updatedFilterData);
    }
  }

  load() {
    this.filter.paginator.set(this.sort, this.paginator);
    this.dataSource.loadFilter(this.filter);
  }

  onRowClicked(row) {
    this.itemClicked.next(row.SECURE_ID);
  }

  generateExcel(): void {
    let filter = this.filter;
    if (this.updatedFilterData != null) {
      filter = this.updatedFilterData;
    }
  filter.descripcion='';
    this.dialog.open(DownloadExcelDialogComponent, {
        closeOnNavigation: false,
        autoFocus: true,
        data: Builder.newDownloadExcelDialogData (this.textosPredefinidosService, filter, this.i18n('Textos predefindos'), this.sort.direction, this.sort.active)
    });
  }
  selectCurrent(row) {
    this.itemSelected.next(row);
}
}